module.exports = __webpack_public_path__ + "static/media/greenfield.0829a8cc.png";